<template>
  <div class="replys">
    <z-pagination
      desc="暂无回复~"
      :enptyImage="enptyImage"
      :spinning="spinning"
      @loadData="loadData"
      :total="total"
    >
      <div>
        <comment
          v-for="item in replyList"
          :key="item.id"
          :comment-data="item"
          :lately="true"
          :more="true"
          @onDelete="onDelete"
          :infoOpers="['del', 'like', 'tread', 'reply']"
        ></comment>
      </div>
    </z-pagination>
  </div>
</template>
<script>
import zPagination from '@/components/ZPagination'
import comment from '../components/Comment'
// findReplyMyComments 回复我的
import { findReplyMyComments, deleteComment } from '@/api/myQa'
const enptyImage = require('@/assets/course_empty.png')

export default {
  name: '',
  data () {
    return {
      // current: 1,
      params: {
        limit: 10,
        page: 0,
      },
      enptyImage,
      replyList: [],
      total: 0,
      // replySpinning: false,
      spinning: false,
      temList: [],
    }
  },
  watch: {
    // current(val) {
    //   this.params.page = parseInt(val) - 1
    //   this.findReplyMyCommentsAsync(this.params)
    // }
  },
  components: {
    comment,
    zPagination
  },
  created () {
    this.findReplyMyCommentsAsync(this.params)
  },
  methods: {
    loadData (ev) {
      this.params.page = parseInt(ev) - 1
      this.findReplyMyCommentsAsync(this.params)
    },
    async findReplyMyCommentsAsync (params) {
      try {
        // this.replySpinning = true
        this.spinning = true
        const { commentNum, list } = await findReplyMyComments(params)
        console.log(commentNum, list)
        this.replyList = list
        this.total = commentNum
      } catch (error) {
        console.log(error)
      } finally {
        // this.replySpinning = false
        this.spinning = false
      }
    },
    // 删除贴子
    async onDelete ({ themeId, userId, id: commentId }) {
      try {
        this.spinning = true
        const res = await deleteComment({ commentId, themeId, userId })
        if (res) {
          this.$message.success('删除成功')
          this.findReplyMyCommentsAsync(this.params)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.spinning = false
      }
    },
  }
}
</script>
<style lang="less" scoped>

.replys {
  padding-bottom: 28px;
  margin-top: -16px;
  .ant-pagination {
    margin-top: 18px;
    text-align: center;
  }
}
</style>
